module.exports = __webpack_public_path__ + "img/dy2.e1510e3f.png";